import {ChangeDetectionStrategy, Component, Input} from '@angular/core';


@Component({
    selector: 'app-round-status',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './round-status.component.html',
    styleUrls: [
        './round-status.component.scss',
    ],
    standalone: false
})
export class RoundStatusComponent {
  @Input() public type = '';

}
